import styled from 'styled-components';

export const StyledCocktailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin: 50px auto;
  grid-gap: 50px;
  max-width: 80%;
`